import React from 'react';
import { Layers, Calculator, FileCheck } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      icon: <Layers className="w-8 h-8 text-emerald-600" />,
      title: "1. Escolha seu Ramo",
      description: "O sistema adapta ferramentas para fabricação sob medida, serviços técnicos com equipe ou comércio e balcão."
    },
    {
      icon: <Calculator className="w-8 h-8 text-emerald-600" />,
      title: "2. Defina Custos e Valor Hora",
      description: "Informe matéria-prima, despesas fixas e meta de ganho. O R-MAX calcula o preço exato sem margem de erro."
    },
    {
      icon: <FileCheck className="w-8 h-8 text-emerald-600" />,
      title: "3. Emita Orçamentos, OS ou PDV",
      description: "Gere propostas comerciais profissionais em PDF para WhatsApp, ordens de serviço com fotos ou opere a frente de caixa."
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white border-b border-slate-200" aria-labelledby="how-it-works-heading">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 id="how-it-works-heading" className="text-3xl md:text-5xl font-extrabold text-slate-950 mb-4 md:mb-6 tracking-tight">
            Como o R-MAX Funciona
          </h2>
          <p className="text-slate-600 text-base md:text-lg max-w-2xl mx-auto px-4 md:px-0 font-normal">
            Três passos objetivos para organizar a rotina do seu negócio e garantir lucro real.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-12 relative">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-linear-to-r from-transparent via-slate-200 to-transparent -translate-y-1/2 z-0" aria-hidden="true"></div>

          {steps.map((step, index) => (
            <div key={index} className="relative z-10 flex flex-col items-center text-center group">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-emerald-50 border-2 border-emerald-200 flex items-center justify-center mb-6 md:mb-8 group-hover:border-emerald-500 group-hover:shadow-md transition-all duration-300 shadow-xs" aria-hidden="true">
                <div className="scale-75 md:scale-100">{step.icon}</div>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-slate-900 mb-3 md:mb-4">{step.title}</h3>
              <p className="text-slate-600 text-sm md:text-base leading-relaxed font-normal px-4 md:px-0">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(HowItWorks);
